import $ from 'jquery';
import 'slick-carousel';

$(window).on('load resize', function () {
  if ($(window).width() < 1360) {
    $('.featured_list:not(.slick-initialized)').slick({
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false,
    });
  } else {
    $('.featured_list.slick-initialized').slick('unslick');
  }
});
